import React from 'react';
import { Stepper } from '@operations/shared';
import DiscountOffer from './DiscountOffer';
import SelectCompanyOrPartner from '../../components/SelectCompanyOrPartner';

const CreateOffer: React.FC = () => {
    const componentSteps = [
        {
            title: 'Select Company or Partner',
            content: <SelectCompanyOrPartner />,
            id: 0,
        },

        {   
            title: 'Create Offer',
            content: <DiscountOffer />,
            id: 1,
        },
    ];

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

export default CreateOffer;
